import util from '@/tools/commonUtil'

const validQuLogics = async function (question, logic, quItem, toQuItem, value, anQuItemId) {
  let isShow = true
  const { chooseType, logicType } = logic
  if (logicType === '1' || logicType === '2') {
    isShow = commonValidLogic(chooseType, value, anQuItemId)
    if (!isShow) {
      return isShow
    }
  } else if (logicType === '3' || logicType === '4') {
    if (!commonValidLogic(chooseType, value, anQuItemId)) {
      this.setLogicValue(logic, toQuItem)
    }
  }
  return isShow
}
const getQuBeforLogicsExpress = function (logic, quItem, value, anQuItemId) {
  let resultStr = true
  const { chooseType } = logic
  resultStr = !commonValidLogic(chooseType, value, anQuItemId)
  return resultStr
}

const commonValidLogic = (chooseType, value, anQuItemId) => {
  let isShow = true
  let stashValue = []
  if (value && value.length === 1) {
    stashValue = value
  } else {
    stashValue = [value.join('-')]
  }

  if (chooseType === '1') {
    if (util.isContainsArr(stashValue, anQuItemId)) {
      isShow = false
      return false
    }
  } else if (chooseType === '2') {
    if (!util.isContainsArr(stashValue, anQuItemId)) {
      isShow = false
      return false
    }
  }
  return isShow
}

const logic = {
  validQuLogics,
  getQuBeforLogicsExpress
}

export default logic



// WEBPACK FOOTER //
// ./src/components/editor/CascadeBox/logic.js